import { isMobile } from 'react-device-detect';

// 資料送給後端會轉換成 type 跟 subtype
export const receiptTypes = {
    EINVOICE: 0, // 電子發票
    INVOICE: 1, // 傳統發票
    RECEIPT: 2, // 一般紙本收據
    E_COMMERCE_ORDER_RECEIPT: 3 // 電商訂單收據
};

export const receiptSubTypes = {
    MANUALLY: 0, // 手動輸入
    QR_CODE_SCAN: 1, // QR Code 掃描
    CARRIER: 2 // 雲端載具
};

export const currencyTypes = {
    NTD: 0, // 新台幣
    UST: 1 // 美金
};

// 流程送出所使用的 key
export const payloadKey = {
    receiptDate: 'receiptDate',
    receiptNumber: 'receiptNumber',
    receiptRandomNumber: 'receiptRandomNumber',
    imageUrl: 'imageUrl',
    carrierNumber: 'carrierNumber',
    carrierCode: 'carrierCode',
    type: 'type',
    subType: 'subtype',
    agreeTerm: 'agreeTerm'
};

export const inputValidation = (key = '', inputValue) => {
    switch (key) {
        case 'invoiceNumber':
            return inputValue.length === 0
                ? 'label.validate.is_required'
                : inputValue.length === 10
                ? ''
                : 'label.validate.format_wrong';
        case payloadKey.imageUrl:
            // 上傳圖片 FieldUploadReceiptImg 元件內沒有走這邊，送出前檢查才會走這邊
            return Boolean(inputValue) ? '' : 'label.validate.is_required';
        case payloadKey.receiptNumber:
            return inputValue.length === 0 ? 'label.validate.is_required' : '';
        case payloadKey.receiptDate:
            // Invalid Date (object) : 套件返回
            // Ibvalid Date (string) : 邏輯判斷
            // 'YYYY-MM-DD' : 套件返回正確時間
            // null : 空
            return !Boolean(inputValue)
                ? 'label.validate.is_required'
                : typeof inputValue !== 'string' || inputValue === 'Invalid Date'
                ? 'label.validate.invalid_date_format'
                : '';
        case payloadKey.receiptRandomNumber:
            return inputValue.length === 0
                ? 'label.validate.is_required'
                : inputValue.length !== 4
                ? 'label.validate.format_wrong'
                : '';
        case payloadKey.carrierNumber:
            return inputValue.length === 0 ? 'label.validate.is_required' : '';
        case payloadKey.carrierCode:
            return inputValue.length === 0 ? 'label.validate.is_required' : '';
        default:
            break;
    }
};

export const defaultReceiptData = {
    receiptDate: { value: '', errorMessage: '' },
    receiptNumber: { value: '', errorMessage: '' },
    invoiceNumber: {
        value: '',
        errorMessage: '',
        alphabetPart: '',
        numericPart: ''
    },
    receiptRandomNumber: { value: '', errorMessage: '' },
    imageUrl: { value: '', errorMessage: '' },
    carrierNumber: { value: '', errorMessage: '' },
    carrierCode: { value: '', errorMessage: '' }
};

// 透過 Type 來判斷是否要將 invoiceNumber 轉換成 receiptNumber
export const convertNumberFromInvoiceToReceipt = [receiptTypes.EINVOICE, receiptTypes.INVOICE];
export const isNeedConvertNumber = receiptType => {
    return convertNumberFromInvoiceToReceipt.includes(receiptType);
};

// 資料 Submit 會依據這邊組出對應的欄位的資料
export const submitReceiptDataKey = {
    // 電子發票
    [receiptTypes.EINVOICE]: {
        // 手動輸入
        [receiptSubTypes.MANUALLY]: [
            payloadKey.receiptDate,
            payloadKey.receiptNumber,
            payloadKey.receiptRandomNumber
        ],
        // 載具輸入
        [receiptSubTypes.CARRIER]: [
            payloadKey.receiptDate,
            payloadKey.receiptNumber,
            payloadKey.carrierNumber,
            payloadKey.carrierCode
        ]
    },
    // 傳統發票
    [receiptTypes.INVOICE]: {
        // 手動輸入
        [receiptSubTypes.MANUALLY]: [
            payloadKey.receiptDate,
            payloadKey.receiptNumber,
            payloadKey.imageUrl
        ]
    },
    // 一般收據
    [receiptTypes.RECEIPT]: {
        // 手動輸入
        [receiptSubTypes.MANUALLY]: [
            payloadKey.receiptDate,
            payloadKey.receiptNumber,
            payloadKey.imageUrl
        ]
    }
};

export const getReceiptDefaultSubType = receiptType => {
    const m = {
        [receiptTypes.EINVOICE]: () =>
            isMobile ? receiptSubTypes.QR_CODE_SCAN : receiptSubTypes.MANUALLY,
        [receiptTypes.INVOICE]: () => receiptSubTypes.MANUALLY,
        [receiptTypes.RECEIPT]: () => receiptSubTypes.MANUALLY
    };
    return typeof m[receiptType] === 'function' ? m[receiptType]() : receiptType;
};
